import { BlogPostSummary, BlogPost} from "./BlogPage.utils"

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

export const fetchBlogPostSummaries= async (): Promise<BlogPostSummary[]> => {
    const response: Response = await fetch(`${API_BASE_URL}/blog/posts`);
    if (!response.ok) {
      throw new Error('Failed to fetch blog posts');
    }
    return response.json();
};

export const fetchBlogPost = async (slug: string): Promise<BlogPost | null> => {
    const response = await fetch(`${API_BASE_URL}/blog/posts/${slug}`);
    if (!response.ok) {
      throw new Error('Failed to fetch blog post');
    }
    return response.json();
};